import React, { Component } from "react";
import { Button, Upload, Collapse, Alert } from "antd";
import { ExcelRenderer } from "react-excel-renderer";
import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import HmgDropdown from "../../components/HmgHotelDropdown/HmgDropdown";
import HmgMainDropdown from "../../components/HmgHotelDropdown/HmgMainDropdown";
import Breadcrumb from "../../components/Breadcrumb";
import "@ant-design/compatible/assets/index.css";
import { connect } from "react-redux";
import { hotelGet, pmsGet, hmgmainGetHmgMain } from "../../store/actions";
import BulkHotelCreationTable from "../../components/BulkCreation/BulkHotelCreation/BulkHotelCreationTable";
import moment from "moment";
import { mypPMSlist } from "../../utils/mappingData";

const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
const statArray = [
  "Report Set-Up Pending",
  "Report Set-Up",
  "WIP Report Set-Up",
  "Client Success",
  "Technical",
  "UAT",
  "Audit I",
  "Audit II",
  "Go Live Pending",
  "Live",
  "Delayed",
  "Pending Business",
  "Future Business",
  "Lost",
  "Sold",
  "Soft Live",
];
const hotellocations = ["IS", "S3"];
const timezones = [
  "AKST",
  "PST",
  "CST",
  "EST",
  "MT",
  "MDT",
  "AST",
  "HST",
  "NST",
];

class BulkHotelCreation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hmgmainSelect: undefined,
      hmgmainList: [],
      hmgselect: undefined,
      cols: [],
      rows: [],
      fileList: [],
      excelData: null,
    };
  }

  async componentDidMount() {
    // if (!this.props.api.hotelGetData) {
    //     await this.props.hotelGet();
    // }
    if (!this.props.api.pmsGetData) {
      await this.props.pmsGet();
    }
    const result = await this.props.hmgmainGetHmgMain();
    this.setState({
      hmgmainList: result,
    });
  }

  changeHmgmainSelect = (e) => {
    this.setState({
      hmgmainSelect: e,
      hmgselect: undefined,
      cols: [],
      rows: [],
      fileList: [],
      excelData: null,
    });
  };

  getProjectList = (e) => {
    const hmgselected = this.state.hmgmainList.find((el) => el._id === e);
    if (hmgselected !== undefined) {
      return hmgselected.projects;
    }
    return [];
  };

  handleHmgChange = async (e) => {
    this.setState({
      hmgselect: e,
      cols: [],
      rows: [],
      fileList: [],
      excelData: null,
    });
  };

  getSignType = (type) => {
    switch (type) {
      case "PandaDoc":
        return "3";
      case "Docusign":
        return "2";
      case "None":
        return "1";
      default:
        return "1";
    }
  };

  preProcessExcelData = (dataRec) => {
    const qc_daily = moment(
      new Date((dataRec.QC_DailyTime - 25569) * 86400 * 1000 + 1)
    )
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");
    const hotel_golive = moment(
      new Date((dataRec.Hotel_Go_Live - 25569) * 86400 * 1000 + 1)
    )
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");
    // tableOneInitialValues[a._id] = {};
    // tableOneInitialValues[a._id] = { ...a };

    dataRec.Hotel_Go_Live = moment(
      hotel_golive,
      "YYYY-MM-DD HH:mm:ss"
    ).isValid()
      ? moment(hotel_golive, "YYYY-MM-DD HH:mm:ss")
      : null;
    dataRec.QC_DailyTime = moment(qc_daily, "YYYY-MM-DD HH:mm:ss").isValid()
      ? moment(qc_daily, "YYYY-MM-DD HH:mm:ss")
      : null;

    const pmsList =
      this.props.api.pmsGetData !== null && !this.props.api.pmsGetData.error
        ? this.props.api.pmsGetData.data
        : [];
    // console.log(dataRec.PMS.split(','),'asd123');
    const pmsrecord = pmsList
      .filter((el) => {
        const pmrec = dataRec.PMS !== undefined ? dataRec.PMS : "";
        return pmrec.split(",").includes(el.pms_name);
      })
      .map((rec) => rec._id);
    dataRec.PMS = pmsrecord;
    // console.log(a,'values a');
    // dataRec.QC_Cutoff_Time = moment(dataRec.QC_Cutoff_Time,'YYYY-MM-DD HH:mm:ss').isValid()?moment(dataRec.QC_Cutoff_Time,'YYYY-MM-DD HH:mm:ss'):null;
    dataRec.HotelLocation = hotellocations.includes(dataRec.HotelLocation)
      ? dataRec.HotelLocation
      : hotellocations[1];
    dataRec.Timezone = timezones.includes(dataRec.Timezone)
      ? dataRec.Timezone
      : undefined;
    dataRec.Sign_Type = this.getSignType(dataRec.Sign_Type);
    dataRec.Status = statArray.includes(dataRec.Status)
      ? dataRec.Status
      : "Live";
    dataRec.QC_WeeklyDay = days.includes(dataRec.QC_WeeklyDay)
      ? dataRec.QC_WeeklyDay
      : undefined;
    dataRec.QC_Enabled = dataRec.QC_Enabled == 1;
    dataRec.QC_SendMissingRptEmail = dataRec.QC_SendMissingRptEmail == 1;
    dataRec.QC_SendEscalationRptEmail = dataRec.QC_SendEscalationRptEmail == 1;
    dataRec.QC_EscalationIgnoreLevelEmail =
      dataRec.QC_EscalationIgnoreLevelEmail == 1;
    dataRec.QC_EnablePeriodicUpdate = dataRec.QC_EnablePeriodicUpdate == 1;
    dataRec.AI_Enabled = dataRec.AI_Enabled == 1;
    dataRec.Serverless_Migration = dataRec.Serverless_Migration;
    if (
      process.env.REACT_APP_PLATFORM_TYPE &&
      process.env.REACT_APP_PLATFORM_TYPE === "GENERIC"
    ) {
      dataRec.Serverless_Migration = false;
    }

    dataRec.MYP_Create_Or_Update = dataRec.MYP_Create_Or_Update == 1;
    dataRec.IntelliSight_Plus = dataRec.IntelliSight_Plus === 1;

    if (
      process.env.REACT_APP_PLATFORM_TYPE &&
      process.env.REACT_APP_PLATFORM_TYPE === "MARRIOTT"
    ) {
      dataRec.MYP_Create_Or_Update = false;
    }
    // dataRec.MYP_PMS=undefined
    if (dataRec.MYP_Create_Or_Update) {
      const pmsrecord = mypPMSlist.find((el) => el.name === dataRec.MYP_PMS);
      dataRec.MYP_PMS = pmsrecord !== undefined ? pmsrecord.name : undefined;
    } else {
      dataRec.MYP_PMS = undefined;
    }
    if (dataRec.Split_Reports_By_Sub_Header) {
      if (dataRec.Split_Reports_By_Sub_Header.toLowerCase() === "no") {
        dataRec.split_by_sub_header = "0";
      } else if (dataRec.Split_Reports_By_Sub_Header.toLowerCase() === "yes") {
        dataRec.split_by_sub_header = "1";
      } else {
        dataRec.split_by_sub_header = "2";
      }
    } else {
      dataRec.split_by_sub_header = "2";
    }

    return dataRec;
  };

  beforeUpload = (event) => {
    let fileObj = event;

    ExcelRenderer(fileObj, (err, resp) => {
      if (err) {
        console.log(err);
      } else {
        const sendData = [];

        if (resp && resp.rows) {
          let countOne = 0;
          let indexs = [];

          resp.rows.forEach((a) => {
            if (countOne == 0) {
              indexs = a;
            } else {
              let countTwo = 0;
              const sendObject = {};
              sendObject._id = countOne.toString();
              indexs.forEach((b) => {
                sendObject[b] = a[countTwo];
                countTwo++;
              });
              sendData.push(this.preProcessExcelData(sendObject));
            }
            countOne++;
            // console.log(indexs, "indexs");
          });
        }
        // console.log(sendData, "sendData");
        // console.log(resp);
        this.setState({
          cols: resp.cols,
          rows: resp.rows,
          excelData: sendData,
        });
        return false;
      }
    });
    return false;
  };

  handleChange = (info) => {
    let fileList = [...info.fileList];

    // 1. Limit the number of uploaded files
    // Only to show two recent uploaded files, and old ones will be replaced by the new
    fileList = fileList.slice(-1);

    // 2. Read from response and show file link
    fileList = fileList.map((file) => {
      if (file.response) {
        // Component will show file.url as link
        file.url = file.response.url;
      }
      return file;
    });

    this.setState({ fileList });
  };

  //END NEW CODES

  render() {
    const props = {
      beforeUpload: this.beforeUpload,
      onChange: this.handleChange,
      accept: ".xlsx",
      name: "file",
    };

    return (
      <div>
        <div className="container_aa">
          <h3>Bulk Hotel Creation</h3>
          <Breadcrumb
            routes={[
              { path: "/", breadcrumbName: "Dashboard" },
              {
                path: "bulk-hotel-creation",
                breadcrumbName: "Bulk Hotel Creation",
              },
            ]}
          />
        </div>
        <div>
          <div className="container_ab">
            <Alert
              style={{ marginBottom: "24px" }}
              message="The first record in the excel is a sample format. Please remove the sample record before submitting hotel bulk upload."
              type="warning"
              showIcon
              closable
            />
            <HmgMainDropdown
              hmgmainSelect={this.state.hmgmainSelect}
              hmgmainList={this.state.hmgmainList}
              hmgmainChange={this.changeHmgmainSelect}
              hmgmainStyles={{
                labelCol: { style: { width: "180px" } },
                wrapperCol: { style: { width: "400px" } },
                style: { marginBottom: 8 },
              }}
            />
            <HmgDropdown
              hmgSelect={this.state.hmgselect}
              handleHmgChange={this.handleHmgChange}
              loadHotelList={() => {}}
              projectList={this.getProjectList(this.state.hmgmainSelect)}
              hmgStyles={{
                labelCol: { style: { width: "180px" } },
                wrapperCol: { style: { width: "400px" } },
              }}
            />
            <div style={{ marginBottom: "20px" }}>
              <Button
                href="/excel-template/bulk_hotel_creation.xlsx"
                type="primary"
                shape="round"
                icon={<DownloadOutlined />}
                size="middle"
              >
                Download Template
              </Button>
            </div>
            <div style={{ marginBottom: "20px" }}>
              <Upload {...props} fileList={this.state.fileList}>
                <Button>
                  <UploadOutlined /> Click to Upload
                </Button>
              </Upload>
            </div>
            {this.props.api.pmsGetData && this.state.excelData ? (
              <BulkHotelCreationTable
                excelData={this.state.excelData}
                hmgSelect={this.state.hmgselect}
                pms={
                  this.props.api.pmsGetData !== null &&
                  !this.props.api.pmsGetData.error
                    ? this.props.api.pmsGetData.data
                    : []
                }
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  hotelGet: () => dispatch(hotelGet()),
  pmsGet: () => dispatch(pmsGet()),
  hmgmainGetHmgMain: () => dispatch(hmgmainGetHmgMain()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BulkHotelCreation);
